import { TimeRangeValue } from '@chronosphereio/core';
import { z } from 'zod/v4';

// TODO: use regex to validate duration
export const durationSchema = z.string();

export const timeOptionSchema = z.enum(['default', 'monthly']);

export type NamedTimeOption = z.infer<typeof timeOptionSchema>;

export const timeDashboardSchema = z.object({
  /**
   * Name time options for predefined custom ranges like 'monthly'.
   */
  options: timeOptionSchema.optional(),
  /**
   * Absolute start time, when defined this takes priority over saved 'duration'.
   */
  start: z.string().optional(),
  /**
   * Absolute end time, must be defined with 'start' time to be valid.
   */
  end: z.string().optional(),
});

export interface DashboardTimeDefinition extends z.TypeOf<typeof timeDashboardSchema> {}

export interface TimeOption {
  value: TimeRangeValue;
  display?: string;
}
